
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Progress from '../progress/index.vue'
import { BizAboutSwiperConfig, CommoditySwiperConfig } from '@xt/client/types/home'

@Component({
  components: {
    Progress
  }
})
export default class extends Vue {
  @Prop({ default: () => [] }) list: Array<BizAboutSwiperConfig | CommoditySwiperConfig>
  @Prop({ default: 0 }) activeIndex: number
  @Prop({ default: 3000 }) duration: number

  @Emit('scroll-to')
  handleScrollTo(index: number): number {
    return index
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
